export const formatPercentage = val => {
  const validInput = typeof val === 'number' && val !== 0;
  return validInput ? `${val}%` : null;
};
